import {
  getTeamsApi,
  createTeamApi,
  pendingInvitesApi,
  inviteUserApi,
  updateInviteApi,
  updateEmployeeRoleApi,
  changeDefaultTeamApi,
  removeEmployeeApi,
  updateTeamApi,
  deleteTeamApi,
  getCohortTeamEmployeesApi,
} from 'api/team';
import Employee from 'models/employee';
import OrgTeam from 'models/orgTeam';
import PendingInvite from 'models/pendingInvite';

export const getTeams = ({ teamId }) =>
  // return getTeamsApi({ teamId }).then(res => res.entity);
  getTeamsApi({ teamId }).then((res) => OrgTeam.fromJSON(res.entity));

export const createTeam = ({ teamName, teamType }) =>
  createTeamApi({ teamName, teamType }).then((res) => new Employee(null, res.entity));

export const getPendingInvites = (employeeId) =>
  pendingInvitesApi(employeeId).then((res) => res.entity.map((o) => PendingInvite.fromJSON(o)));

export const inviteUser = ({ email, teamUuid, widgetType = '' }) =>
  inviteUserApi({ email, teamUuid, widgetType }).then((res) => res);

export const acceptInvite = ({ email, teamUuid }) => {
  const status = 'USER_ACCEPTED';
  return updateInviteApi({ email, teamUuid, status }).then((res) => new Employee(null, res.entity));
};

export const declineInvite = ({ email, teamUuid }) => {
  const status = 'USER_DECLINED';
  return updateInviteApi({ email, teamUuid, status }).then((res) => new Employee(null, res.entity));
};

export const updateEmployeeRole = ({ newRole, employeeId, teamId }) =>
  updateEmployeeRoleApi({ newRole, employeeId, teamId }).then((res) => res.entity);

export const changeDefaultTeam = ({ employeeId, teamId }) =>
  changeDefaultTeamApi({ employeeId, teamId }).then((res) => new Employee(null, res.entity));

export const removeEmployee = ({ employeeId, teamId }) => removeEmployeeApi({ employeeId, teamId }).then((res) => res);

export const updateTeam = ({ teamId, teamName, visibilityType, teamType }) =>
  updateTeamApi({ teamId, teamName, visibilityType, teamType }).then((res) => res);

export const deleteTeam = (teamId) => deleteTeamApi(teamId);

export const getCohortTeamEmployees = ({ selectedCohort = null }) =>
  getCohortTeamEmployeesApi({ selectedCohort }).then((res) =>
    res.entity.map((emp) => ({
      avatar: emp.profilePhoto,
      label: emp.displayName,
      designation: emp.designation,
      value: emp.id,
    }))
  );
